module.exports = __webpack_public_path__ + "static/media/expanded_recommended_loan.47193c9e.png";